/* Modulo: Offer Banner
   The phone rotation is pure CSS and needs none of this. The script only adds
   what CSS cannot do:
   1. The pause button (WCAG 2.2.2). It ships `hidden`, so a shopper without
      the script never meets a button that does nothing.
   2. Keyboard focus on a perk link, or the theme editor selecting a perk,
      HOLDS the rotation on that perk: a focus ring is never drawn on a perk
      that is faded out, and the merchant sees the perk they are editing.
   3. Offscreen, the rotation pauses.
   Emitted only when phones rotate two or more perks. */
(function () {
  'use strict';
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  function perkOf(node) {
    return node && node.closest ? node.closest('[data-bo-perk]') : null;
  }

  function hold(perks, perk) {
    var items = perks.querySelectorAll('[data-bo-perk]');
    for (var i = 0; i < items.length; i++) items[i].classList.toggle('is-focus', items[i] === perk);
    perks.classList.add('is-held');
  }

  /* Releasing removes the hold class, and with it `animation: none`, so every
     perk and the ring restart together from the first perk and stay in step. */
  function release(perks) {
    perks.classList.remove('is-held');
    var items = perks.querySelectorAll('.is-focus');
    for (var i = 0; i < items.length; i++) items[i].classList.remove('is-focus');
  }

  function init(root) {
    if (!root || root.__moduloBo) return;
    var perks = root.querySelector('[data-bo-perks]');
    if (!perks) return;
    root.__moduloBo = true;

    var btn = perks.querySelector('[data-bo-pause]');
    if (btn) {
      btn.hidden = false;
      /* A label swap and no aria-pressed: a toggle that renames itself AND
         reports a pressed state is announced twice (the ARIA APG pattern). */
      btn.addEventListener('click', function () {
        var paused = perks.classList.toggle('is-paused');
        btn.classList.toggle('is-play', paused);
        btn.setAttribute('aria-label', btn.getAttribute(paused ? 'data-label-play' : 'data-label-pause') || '');
      });
    }

    perks.addEventListener('focusin', function (e) {
      var perk = perkOf(e.target);
      if (perk && perks.contains(perk)) hold(perks, perk);
    });
    perks.addEventListener('focusout', function (e) {
      var next = perkOf(e.relatedTarget);
      if (next && perks.contains(next)) return;
      release(perks);
    });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          perks.classList.toggle('is-offscreen', !entries[i].isIntersecting);
        }
      });
      io.observe(perks);
      root.__moduloBoIo = io;
    }
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-modulo-bo]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  /* Document listeners are wired ONCE: an identical <script src> still executes
     once per tag, so two banners on a page would otherwise bind each twice. */
  if (!window.__moduloBoWired) {
    window.__moduloBoWired = true;

    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
    document.addEventListener('shopify:section:unload', function (e) {
      var roots = e.target && e.target.querySelectorAll ? e.target.querySelectorAll('[data-modulo-bo]') : [];
      for (var i = 0; i < roots.length; i++) {
        if (roots[i].__moduloBoIo) roots[i].__moduloBoIo.disconnect();
      }
    });

    /* The theme editor fires these on the block's own element. */
    document.addEventListener('shopify:block:select', function (e) {
      var perk = perkOf(e.target);
      var perks = perk ? perk.closest('[data-bo-perks]') : null;
      if (perks) hold(perks, perk);
    });
    document.addEventListener('shopify:block:deselect', function (e) {
      var perk = perkOf(e.target);
      var perks = perk ? perk.closest('[data-bo-perks]') : null;
      if (perks) release(perks);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
})();
